var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.pod_idle)?_c('section',{staticClass:"w-spalsh-screen",staticStyle:{"z-index":"1"}},[_c('div',{staticClass:"lds-dual-ring px-2"})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }